import {UseQueryResult, useQuery} from '@tanstack/react-query'
import {useMemo} from 'react'
import {EntitlementsService} from 'services/api'
import {EntitlementsData} from 'interfaces'

interface UseEntitlementsOptions {
  enabled?: boolean
}

export const ENTITLEMENTS_QUERY_KEY = 'getEntitlements'

type UseEntitlementsQueryResult = Partial<EntitlementsData> & {
  swgDlpBlock: boolean
  casbFullAccess: boolean
} & Pick<
    UseQueryResult<EntitlementsData>,
    'isLoading' | 'isFetching' | 'isSuccess' | 'isError' | 'refetch'
  >

const defaultEntitlements = {
  swgDlpBlock: false,
  casbFullAccess: false,
}

export const useEntitlementsQuery = ({
  enabled = false,
}: UseEntitlementsOptions = {}): UseEntitlementsQueryResult => {
  const {data, isLoading, isFetching, isSuccess, isError, refetch} = useQuery({
    queryKey: [ENTITLEMENTS_QUERY_KEY],
    queryFn: () => EntitlementsService.getEntitlements(),
    enabled,
  })

  const entitlementsData = useMemo(
    () => ({...defaultEntitlements, ...data}),
    [data],
  )

  return {
    ...entitlementsData,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    refetch,
  }
}
